// Smart catch-all for /cruises/:slug routes.
// If the slug exists in the rich EVENT_LANDINGS dataset (incl. SEO_EVENT_LANDINGS),
// render the long-form EventLanding template. Otherwise fall back to the legacy
// SEOLanding template (which reads from SEO_PAGES).
import React from "react";
import { useParams } from "react-router-dom";
import { EVENT_LANDINGS } from "../data/eventLandings";
import EventLanding from "./EventLanding";
import SEOLanding from "./SEOLanding";

export default function CruiseSlugResolver() {
  const { slug } = useParams();
  if (slug && EVENT_LANDINGS[slug]) return <EventLanding />;
  return <SEOLanding />;
}
